module.exports = __webpack_public_path__ + "static/logo-fill-3fb4d55dfd67bd72c5259987c67bb3ea.png";